import { ChangeDetectionStrategy, Component, computed, input, model } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-search-bar',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormsModule, MatIconModule],
  template: `
    <label class="search-bar">
      <mat-icon aria-hidden="true">search</mat-icon>
      <input type="search" [attr.aria-label]="accessibleName()" [placeholder]="placeholder()" [(ngModel)]="value" />
    </label>
  `,
  styles: `
    :host {
      display: flex;
    }
    .search-bar {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      height: 2.625rem;
      padding: 0 0.875rem;
      background: var(--to-card);
      border: 1.5px solid var(--to-border);
      border-radius: 0.625rem;
      width: 100%;
      min-width: 14rem;
      max-width: 24rem;
      cursor: text;
      transition: border-color 0.12s;
      box-sizing: border-box;

      &:focus-within {
        border-color: var(--to-brand);
      }

      mat-icon {
        font-size: 1.125rem;
        width: 1.125rem;
        height: 1.125rem;
        color: var(--to-text-muted);
        flex-shrink: 0;
      }

      input {
        flex: 1;
        border: none;
        outline: none;
        background: transparent;
        font-size: 0.875rem;
        color: var(--to-text);
        font-family: inherit;
        min-width: 0;

        &::placeholder {
          color: var(--to-text-muted);
        }
        &::-webkit-search-cancel-button {
          display: none;
        }
      }
    }
  `,
})
export class SearchBarComponent {
  readonly placeholder = input<string>('');
  /**
   * Optionaler zugaenglicher Name des Suchfelds. Ohne Wert faellt der Name
   * auf den Platzhalter zurueck — reicht, solange der Platzhalter beschreibend
   * ist. Enthaelt der Platzhalter nur ein Beispiel (z. B. „z. B. TR-127"),
   * muss der Aufrufer diesen Input setzen, sonst hoert der Screenreader den
   * Beispielwert als Label (NEX-1054-Review).
   */
  readonly ariaLabel = input<string>('');
  readonly value = model<string>('');

  readonly accessibleName = computed(() => this.ariaLabel() || this.placeholder());
}
